import { cr } from "fire-wind-water/core";
export const FileType = {
  audio: [
    "cd",
    "wave",
    "aiff",
    "au",
    "mp3",
    "midi",
    "wma",
    "realaudio",
    "vqf",
    "oggvorbis",
    "aac",
    "ape"
  ],
  excel: ["xls", "xlsx", "csv"],
  pdf: ["pdf"],
  ppt: ["ppt", "pptx"],
  txt: ["txt"],
  video: ["avi", "wma", "rmvb", "rm", "swf", "mp4", "mid", "3gp"],
  word: ["doc", "docx"],
  zip: ["zip", "rar"],
  img: ["png", "jpg"]
};

const FileTypeJosn = {};
cr.each(FileType, (d, t) => {
  cr.each(d, o => {
    FileTypeJosn[o] = t;
  });
});

export { FileTypeJosn };

export const PASSWORD = [
  {
    fieldName: "oldPwd",
    displayName: "旧密码",
    fieldType: "TEXT",
    required: 1,
    textRegularExpression: "^[^\u4E00-\u9FA5]{6,20}$",
    errorMessage: "请输入6~20个字符"
  },
  {
    fieldName: "newPwd",
    displayName: "新密码",
    fieldType: "TEXT",
    required: 1,
    textRegularExpression: "^[^\u4E00-\u9FA5]{6,20}$",
    errorMessage: "请输入6~20个字符"
  },
  {
    fieldName: "confirmPwd",
    displayName: "确认密码",
    fieldType: "TEXT",
    required: 1,
    textRegularExpression: "^[^\u4E00-\u9FA5]{6,20}$",
    errorMessage: "请输入6~20个字符"
  }
];
